import { useEffect, useState } from 'react'
import Button from './ui/Button'

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  showInput = false,
  inputDefaultValue = '',
  inputLabel,
  onConfirm,
  onCancel,
  children,
}) {
  const [value, setValue] = useState(inputDefaultValue)

  useEffect(() => {
    if (open) setValue(inputDefaultValue)
  }, [open, inputDefaultValue])

  useEffect(() => {
    if (!open) return
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCancel()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onCancel])

  if (!open) return null

  const confirmDisabled = showInput && value.trim() === ''

  const handleConfirm = () => {
    if (confirmDisabled) return
    onConfirm(showInput ? value : undefined)
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onCancel()
  }

  return (
    <div
      className="fixed inset-0 bg-gray-900/50 flex items-center justify-center z-50 p-4"
      onClick={handleOverlayClick}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="bg-white rounded-xl shadow-xl border border-gray-200 p-6 w-full max-w-sm"
      >
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {message && (
          <p className="text-sm text-gray-500 mt-1">{message}</p>
        )}

        {showInput && (
          <div className="mt-4">
            {inputLabel && (
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {inputLabel}
              </label>
            )}
            <input
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              autoFocus
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors duration-200"
            />
          </div>
        )}

        {children}

        <div className="flex gap-3 mt-6">
          <Button variant="secondary" fullWidth onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="primary" fullWidth onClick={handleConfirm} disabled={confirmDisabled}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
